import * as React from 'react';
import { FormWidgetItem } from './wrapper/FormWidgetItem';
import { IWidget } from 'common/schema/widget/Widget';
import { UploadInputWrapper } from 'client/ui/form/input/UploadInputWrapper';
import { MetadataLogic } from 'common/schema/metadata/MetadataLogic';
import { useRequestCompileContext } from '../../requests/compile-context/RequestCompileContext';
import { WidgetUploadInput } from './upload/WidgetUploadInput';
import { useField } from 'formik';
import { IRequestFileValue } from 'common/schema/request/Request';
import { UploadedFileField } from './upload/UploadedFileField';

export interface FormWidgetInputFileViewProps {
  widget: IWidget;
}

export function FormWidgetInputFileView(props: FormWidgetInputFileViewProps) {
  const { widget } = props;

  const { request } = useRequestCompileContext();

  // Abbiamo un singolo metadato per i campi di tipo file
  const metadata = MetadataLogic.singleFromWidget(widget);
  const name = `values.${metadata.id}`;
  const options = widget.input?.validation;

  const [field, meta, helpers] = useField<IRequestFileValue>(name);

  if (!options?.multiple && field.value && field.value.length > 0) {
    return (
      <FormWidgetItem name={name} widget={widget}>
        <UploadedFileField name={name} ellipsis={38} />
      </FormWidgetItem>
    );
  }

  return (
    <FormWidgetItem name={name} widget={widget}>
      <UploadInputWrapper>
        <WidgetUploadInput
          metadata={metadata}
          name={name}
          options={options}
          description={widget.input?.extra?.uploadDescription}
          procedureId={widget.procedureId}
          widgetType={widget?.input?.type}
        />
      </UploadInputWrapper>
    </FormWidgetItem>
  );
}
